/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Document } from "./Document";
export const ListDocumentsResponse = core.serialization.object({
    data: core.serialization.list(Document),
});
